// extracted by mini-css-extract-plugin
module.exports = {"flexInput":"_35Hz9gu","inputRow":"_1n1lGkM","results":"_3xESB-p","result":"_o4byNc","resultHeader":"_3-L4Q75","resultPlz":"Fd8iZru","resultMeta":"_2VDwN9r"};